import {mapState, mapActions} from 'vuex'
import {gsap} from 'gsap'

new Vue({
    el: '#loading',
    name: 'Loading',
    store: window.store,
    computed: {
        ...mapState('defaults', {
            currentedPage: (state) => state.currentedPage,
            isLoading: (state) => state.isLoading,
        }),
    },
    methods: {
        handleIndexLoading() {
            gsap.set(['#carpenter-white .school,#carpenter-white .text'], {y: 100})

            new Vivus('carpenter-logo', {
                type: 'delayed',
                duration: 1000,
                animTimingFunction: Vivus.EASE_OUT
            });
            const tl = gsap.timeline({duration: 3, onComplete: this.handleLoading});
            tl.to('#carpenter-white .school', {
                y: 0,
            }, '<2');
            // tl.to('#carpenter-white .text', {
            //     y: 0,
            // }, '<1.5');
            tl.to('.m-loading', {
                y: '-100%',
            }, '<0.5')

        },
    
    },
    mounted() {


        this.$nextTick(() => {
            this.handleIndexLoading()
        })
    },
});
